import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import { useState, useCallback } from 'react';

/**
 * Creates a ref from an element that is held in a state variable
 * to be used a dependency for component lifecycle changes.
 * See [React docs](https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node)
 *
 * @param {any} initialValue - The initial ref value/element
 * @returns {[any, any]} - An array of the ref and the element
 */

var useElementRef = function useElementRef(initialValue) {
  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      element = _useState2[0],
      setElement = _useState2[1];

  var ref = useCallback(function (node) {
    if (node !== null) {
      setElement(node);
    }
  }, []);
  return [ref, element];
};

export default useElementRef;
